import { Component, HostBinding } from '@angular/core';
import { DateTime } from 'luxon';
import { DIST_VERSION } from '../../../../environments/dist.version';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  @HostBinding('class') classes: string = 'main-footer';
  public appVersion = DIST_VERSION;
  public currentYear: string = DateTime.now().toFormat('y');
}
